import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { Tooltip } from 'antd';
import { FaFacebook, FaShare, FaWhatsapp, FaXTwitter } from 'react-icons/fa6';
import { GrLinkedin } from 'react-icons/gr';
import { MdOutlineAttachEmail, MdOutlineContentCopy } from 'react-icons/md';
import { LinkedinShareButton, FacebookShareButton, TwitterShareButton, WhatsappShareButton } from 'react-share';
import { toast } from 'react-toastify';

const SocialShare = ({ shareUrl }) => {
    const title = "Hi use this link to view the event details";

    const copyToClipboard = () => {
        navigator.clipboard.writeText(shareUrl);
        toast.success("Link copied to clipboard")
    };

    return (
        <div className="relative">
            <Menu as="div" className="relative">
                <Tooltip title="Social Share">
                    <MenuButton className="shadow_div flex cursor-pointer shadow-[0px_0px_12px_-5px_#000] flex-col items-center justify-center w-8 h-8 bg-white rounded-full text-[14px] focus:outline-none hover:opacity-[90%]">
                        <FaShare />
                    </MenuButton>
                </Tooltip>
                <MenuItems transition anchor="bottom end" className="menu_dropdown absolute right-0 top-2 mt-2 w-48 bg-white border rounded-lg shadow-lg z-10">
                    <div className="py-2">
                        {/* Copy to Clipboard */}
                        <MenuItem>
                            {({ active }) => (
                                <div onClick={copyToClipboard} className={`flex items-center space-x-1 text-[12px] px-4 py-1 ${active ? 'bg-gray-100' : ''} cursor-pointer`}>
                                    <MdOutlineContentCopy />
                                    <span className="text-gray-800">Copy Link</span>
                                </div>
                            )}
                        </MenuItem>

                        {/* Whatsapp Share */}
                        <MenuItem>
                            {({ active }) => (
                                <WhatsappShareButton
                                    url={shareUrl}
                                    title={title}
                                    separator=":: "
                                >
                                    <div className={`flex items-center space-x-1 text-[12px] px-4 py-1 ${active ? 'bg-gray-100' : ''} cursor-pointer`}>
                                        <FaWhatsapp />
                                        <span>Whatsapp</span>
                                    </div>
                                </WhatsappShareButton>
                            )}
                        </MenuItem>

                        {/* Facebook Share */}
                        <MenuItem>
                            {({ active }) => (
                                <FacebookShareButton
                                    url={shareUrl}
                                    quote={title}
                                >
                                    <div className={`flex items-center space-x-1 text-[12px] px-4 py-1 ${active ? 'bg-gray-100' : ''} cursor-pointer`}>
                                        <FaFacebook />
                                        <span>Facebook</span>
                                    </div>
                                </FacebookShareButton>
                            )}
                        </MenuItem>

                        {/* Twitter Share */}
                        <MenuItem>
                            {({ active }) => (
                                <TwitterShareButton
                                    url={shareUrl}
                                    title={title}
                                >
                                    <div className={`flex items-center space-x-1 text-[12px] px-4 py-1 ${active ? 'bg-gray-100' : ''} cursor-pointer`}>
                                        <FaXTwitter />
                                        <span>Twitter</span>
                                    </div>
                                </TwitterShareButton>
                            )}
                        </MenuItem>

                        {/* Email Share */}
                        <MenuItem>
                            {({ active }) => (
                                <div className={`flex items-center space-x-1 text-[12px] px-4 py-1 ${active ? 'bg-gray-100' : ''} cursor-pointer`}>
                                    <MdOutlineAttachEmail />
                                    <a href={`mailto:?subject=Share URL&body=${title} ${shareUrl}`} className="text-gray-800">Email</a>
                                </div>
                            )}
                        </MenuItem>

                        {/* Linkedin Share */}
                        <MenuItem>
                            {({ active }) => (
                                <LinkedinShareButton
                                    url={shareUrl}
                                    title={title}
                                >
                                    <div className={`flex items-center space-x-1 text-[12px] px-4 py-1 ${active ? 'bg-gray-100' : ''} cursor-pointer`}>
                                        <GrLinkedin />
                                        <span>Linkedin</span>
                                    </div>
                                </LinkedinShareButton>
                            )}
                        </MenuItem>
                    </div>
                </MenuItems>
            </Menu>
        </div>
    );
};

export default SocialShare;